/** Time is integer milliseconds in the project; frames are derived, never stored. */
export function frameCount(durationMs: number, fps: number): number {
  return Math.max(1, Math.round((durationMs * fps) / 1000));
}
export function frameToMs(frame: number, fps: number): number {
  return Math.round((frame * 1000) / fps);
}
export function msToFrame(ms: number, fps: number): number {
  return Math.round((ms * fps) / 1000);
}
